import { render, staticRenderFns } from "./FeedLocalization.vue?vue&type=template&id=e850926c&scoped=true&"
import script from "./FeedLocalization.vue?vue&type=script&lang=js&"
export * from "./FeedLocalization.vue?vue&type=script&lang=js&"
import style0 from "./FeedLocalization.vue?vue&type=style&index=0&id=e850926c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e850926c",
  null
  
)

export default component.exports